import axios from "@/plugins/axios";
import GetRecordStampResponse from "@/models/api/recordStamp/GetRecordStampResponse";

export const URL_GET_RECORD_STAMP_MODIFICATIONS = "/RecordStamp/${RecordStampId}";

export const getRecordStamp = async (recordStampId: number): Promise<GetRecordStampResponse> => {
  const response = await axios.get(URL_GET_RECORD_STAMP_MODIFICATIONS, { params: { RecordStampId: recordStampId } });
  return response.data as GetRecordStampResponse;
};
